import { graphql } from "gatsby";
import React from "react";
import Content from "../components/blog/Content";
import Header from "../components/blog/Header";
import Seo from "../components/common/seo";
import Layout from "../components/common/layout";

const Blog = ({ data, pageContext }) => {
  const blogData = data.sanityBlog;
  const cta = pageContext?.cta;

  console.log(data);

  return (
    <Layout whiteText={true}>
      <Header
        title={blogData.blogTitle}
        subTitle={blogData?.blogSubTitle}
        author={blogData?.author}
        publishedAt={blogData.publishedAt}
        categories={blogData.categories}
        tags={blogData.tags}
        thumbnailImage={blogData.thumbnailImage}
        featured={blogData.featured}
      />
      <Content
        data={blogData}
        cta={cta}
        prev={data?.sanityPrevBlog}
        next={data?.sanityNextBlog}
      />
    </Layout>
  );
};

export function Head({ location, data }) {
  const seo = {
    title: data?.sanityBlog?.seo?.title || data?.sanityBlog?.blogTitle,
    description:
      data?.sanityBlog?.seo?.description || data?.sanityBlog?.overview,
    keywords: data?.sanityBlog?.seo?.keywords,
    ldSchema: data?.sanityBlog?.seo?.ldSchema,
    image: data?.sanityBlog?.thumbnailImage?.image?.asset?.url,
  };

  return <Seo location={location} data={seo} />;
}

export const query = graphql`
  query Blog($slug: String, $prev: String, $next: String) {
    sanityPrevBlog: sanityBlog(slug: { current: { eq: $prev } }) {
      id
      blogTitle
      slug {
        current
      }
    }
    sanityNextBlog: sanityBlog(slug: { current: { eq: $next } }) {
      id
      blogTitle
      slug {
        current
      }
    }
    sanityBlog(slug: { current: { eq: $slug } }) {
      id
      seo {
        title
        pagehandle
        description
        keywords
        ldSchema
      }
      pageTitle
      blogTitle
      slug {
        current
      }
      blogSubTitle
      author {
        name
        bio
      }
      publishedAt
      categories {
        name
        slug {
          current
        }
      }
      tags {
        name
        slug {
          current
        }
      }
      thumbnailImage {
        altText
        image {
          asset {
            url
            gatsbyImageData(
              layout: CONSTRAINED
              formats: [WEBP, AUTO]
              placeholder: BLURRED
            )
          }
        }
      }
      overview
      featured
      status
      _rawDescription
    }
  }
`;

export default Blog;
